module.exports = __webpack_public_path__ + "img/camera2.560b88c3.svg";